import React, { Component } from 'react';
import { Row, Col, Affix } from 'antd';
import Helmet from 'react-helmet';
import scrollToComponent from 'react-scroll-to-component';
import * as MetaConstants from '../../../common/constants/metatags';
import LazyLoad from 'react-lazyload';

class HomeComponent extends Component {

	constructor(props) {
		super(props);
		this.state = {
			iconLoading: false
		};
	}

	_scrollToComponent = () => {
		scrollToComponent(this.LearnMore, {
			offset: 0,
			align: 'middle',
			duration: 500,
			ease: 'inCirc'
		});
	};

	render() {
		return (
			<div className='homev2 homev3'>
				<div className='top-bg home-top-bg'>
					<Helmet
						title='Virtual Races, Fitness Challenges and Exercise | Yes.Fit'
						meta={[
							{ 'charset': 'utf-8' },
							{ 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
							{ name: 'description', content: MetaConstants.metaDesc },
							{ name: 'viewport', content: MetaConstants.metaViewport },
							{ name: 'twitter:card', content: MetaConstants.twitterCardType },
							{ name: 'twitter:image', content: MetaConstants.twitterImage },
							{ name: 'twitter:image:alt', content: MetaConstants.metaDesc },
							{ name: 'twitter:site', content: MetaConstants.twitterHandle },
							{ property: 'og:url', content: MetaConstants.metaUrl },
							{ property: 'og:image', content: MetaConstants.ogImage },
							{ property: 'og:title', content: MetaConstants.ogTitle },
							{ property: 'og:locale', content: MetaConstants.ogLocale },
							{ property: 'og:type', content: MetaConstants.ogType },
							{ property: 'og:site_name', content: MetaConstants.ogSiteName },
							{ property: 'og:description', content: MetaConstants.metaDesc },
							{ property: 'fb:app_id', content: MetaConstants.fbAppId }
						]}
						link={[
							{ rel: 'canonical', href: MetaConstants.metaUrl }
						]}
					></Helmet>
					<Affix offsetTop={5} className="anchor-links-wrapper">
						<Row type='flex' justify="center" >
							<div className="anchor-menu-links">
								<ul>
									<li><button onClick={() => scrollToComponent(this.OurEvents)} className="transparent-anchor-link">Our Events
									</button></li>
									<li><button onClick={() => scrollToComponent(this.Membership)} className="transparent-anchor-link">Membership
									</button></li>
									<li><button onClick={() => scrollToComponent(this.Trackers)} className="transparent-anchor-link">Activity Trackers
									</button></li>
									<li><button onClick={() => scrollToComponent(this.Collaborate)} className="transparent-anchor-link">Collaborate
									</button></li>
									{/* <li><button onClick={() => scrollToComponent(this.CorpWell)} className="transparent-anchor-link">Corporate Wellness
									</button></li> */}
								</ul>
							</div>
						</Row>
					</Affix>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 12 }}
							lg={{ span: 10 }}
							xl={{ span: 11 }}
							className="banner-text-block"
						>
							<h1 className='top-text--header home-top-header'>
							Fun &amp; Motivating <br /><span>Fitness for Anyone, Anywhere</span> 
							</h1>
							{/* <p className='top-text--subheader'>Yes.Fit is a mobile app that is focused on fitness. Here’s how it works:</p> */}
							<ol className="how-steps">
								<li className="how-step one">
									Sign up for a Virtual Race or Fitness Challenge
								</li>
								<li className="how-step two">
									Choose your Reward
								</li>
								<li className="how-step three">
									Sync your favorite fitness tracker
								</li>
								<li className="how-step four">
									Walk, run, swim, cycle or exercise at your own pace
								</li>
								<li className="how-step five">
									Enjoy your mile markers and street views along your journey
								</li>
								<li className="how-step six">
									Complete your race or challenge and receive your reward!
								</li>
							</ol>
							<a title='Browse Yes.Fit Events' href="/races" role="button" className="gradient-shadow-button blue">Browse Events</a>
						</Col>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 12 }}
							lg={{ span: 12 }}
							xl={{ span: 11 }}
						>
							<div>
								<LazyLoad>
									<img src="https://asset.yes.fit/homepage/homepage-banner-device-v4-mockup-compressed.png" alt='Yes.Fit mobile App on a mobile phone' title='Yes.Fit Mobile App Banner' className="banner-image-right" />
								</LazyLoad>
							</div>
						</Col>
					</Row>
					<Row>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className="app-download-container"
						>
							<div className="app-download-container-inner">
								<div>
									<h2>Download the App</h2>
									<p>Available on both the Appstore and Google Play Store now.</p>
								</div>
								<div className='app-download-button-group-wrapper'>								
									<div className='app-download-button-group'>
										<a
											href='https://yesfit.app.link/app-store'
											target='_blank'
											title='view our Yes.Fit app on the App Store'
											className='logo-ada-focus'
											role="button" 
										>
											<LazyLoad>
												<img
													alt='Apple App Store Logo' title='Apple App Store logo'
													src='https://asset.yes.fit/homepage/App-Store-Badge-compressed.png'
												/>
											</LazyLoad>
										</a>
									</div>
									<div className='app-download-button-group'>
										<a
											href='https://yesfit.app.link/google-play'
											target='_blank'
											title='view our Yes.Fit app on the Google Play Store'
											className='logo-ada-focus'
											role="button" 
										>
											<LazyLoad>
												<img
													alt='Google Play Store Logo' title='Google Play Store logo'
													src='https://asset.yes.fit/homepage/Google-Store-Badge-compressed.png'
												/>
											</LazyLoad>
										</a>
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</div>

				<div className='band band band-lg white-bg'>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className='text-center'
						>
							<div className="header-with-image-label" ref={section => {this.OurEvents = section;}}>
								<LazyLoad>
									<img alt='Yes.Fit Light Logo' title='Yes.Fit Light Logo' src="https://asset.yes.fit/homepage/yf-logo-opaque-light-compressed.png" />
								</LazyLoad>
								<h2 className="header-logo-behind">What is a Virtual Race?</h2>								
							</div>
							<p className="standard-text">Our virtual races take you to locations all over the world allowing you to experience new destinations via street views in that location. Each logged workout produces a new street view for you to enjoy with the click of a button on your race map. We offer a huge variety of themes, locations and distances for you to choose from. As an added bonus you will receive fun facts, videos and pictures related to the theme as you pass certain mile markers. And don’t forget about the awesome rewards you will receive for achieving your goals. What are you waiting for? Join a race, start logging those miles and become a Virtual World Traveler!</p>
						</Col>
					</Row>
					<Row type='flex'>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
								className='text-center'
							>
								<LazyLoad>
									<img alt='Yes.Fit Virtual Race Banner' title='Yes.Fit Virtual Race Banner' src="https://asset.yes.fit/homepage/top-race-banner-compressed.png" />
								</LazyLoad>
							</Col>
							
						</Row>
						<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className='text-center'
						>
							<a
								href='/races'
								className='gradient-shadow-button green large'
								title='View Our Events'
								role="button" 
							>
								View Our Events
							</a>
						</Col>						
					</Row>
				</div>

				<div					
					className='band band band-lg gradient-bg'>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className='text-center'
						>
							<div className="header-with-image-label">
								<LazyLoad>
									<img alt='Yes.Fit Light Logo' title='Yes.Fit Light Logo' src="https://asset.yes.fit/homepage/yf-logo-opaque-light-compressed.png" />
								</LazyLoad>
								<h2 className="header-logo-behind">What is a Fitness Challenge?</h2>								
							</div>
							<p className="standard-text">Our Fitness Challenges are new and exciting workout videos with Yes.Fit’s very own fitness trainers. We offer monthly and daily challenges allowing you the flexibility to workout at your own pace. Each challenge provides different levels of difficulty for you to choose from as you progress on your fitness journey. Fitness Challenges are exclusively available to VIP Members. </p>
						</Col>
					</Row>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className='text-center'
						>
							<a
								href='/races'
								className='gradient-shadow-button green large'
								title='View Our Events'
								role="button" 
							>
								View Our Events
							</a>
						</Col>						
					</Row>
				</div>
				<div
					ref={section => {
						this.Membership = section;
					}}
					className='band band band-lg white-bg'>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className='text-center'
						>
							<div className="header-with-image-label">
								<LazyLoad>
									<img alt='Yes.Fit Light Logo' title='Yes.Fit Light Logo' src="https://asset.yes.fit/homepage/yf-logo-opaque-light-compressed.png" />
								</LazyLoad>
								<h2 className="header-logo-behind">Do I have to be a Member?</h2>								
							</div>
							<p className="standard-text">No way! You are free to pay race-to-race but there are certainly some perks to becoming a Yes.Fit Member and you have options!</p>
						</Col>
					</Row>
					<Row type='flex'>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 6 }}
								xl={{ span: 6 }}
								className='text-center membership-benefits-block'
							>								
								<h2>Big Discounts</h2>
								<LazyLoad>
									<img alt='Yes.Fit Club Member Big Discounts' title='Yes.Fit Club Member Big Discounts' src="https://asset.yes.fit/homepage/member-discount-compressed.png" />
								</LazyLoad>
								<p><span>CYF Power</span> Members enjoy a 20% discount on all Yes.Fit purchases. This includes Virtual Races and items in our Store.</p>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 6 }}
								xl={{ span: 6 }}
								className='text-center membership-benefits-block'
							>								
								<h2>VIP First Access</h2>
								<LazyLoad>
									<img alt='Yes.Fit Club Member VIP' title='Yes.Fit Club Member Vip' src="https://asset.yes.fit/homepage/member-vip-compressed.png" />
								</LazyLoad>
								<p>You are the very first to gain access to all the new Yes.Fit features as they are released.</p>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 6 }}
								xl={{ span: 6 }}
								className='text-center membership-benefits-block'
							>								
								<h2>Unlimited Digital Races</h2>
								<LazyLoad>
									<img alt='Yes.Fit Club Member Unlimited' title='Yes.Fit Club Member Unlimited' src="https://asset.yes.fit/homepage/member-unlimited-compressed.png" />
								</LazyLoad>
								<p>You get unlimited access to any and all of our digital only events in the app.</p>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 6 }}
								xl={{ span: 6 }}
								className='text-center membership-benefits-block'
							>								
								<h2>Fitness Challenges</h2>
								<LazyLoad>
									<img alt='Yes.Fit Club Member Fitness Challenges' title='Yes.Fit Club Member Fitness Challenges' src="https://asset.yes.fit/homepage/member-challenges-compressed.png" />
								</LazyLoad>
								<p>Only <span>CYF Power</span> members have access to our amazing new Fitness Challenges. Designed for all skill levels!</p>
							</Col>
						</Row>
					<Row type="flex">
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
								className='text-center'>
							<a href="/vip" className="gradient-shadow-button green large centered" title='View Our Membership Plans' role="button">View VIP Plans</a>
							</Col>
						</Row>
				</div>

				<div
					ref={section => {
						this.Trackers = section;
					}}
					className='band band band-lg gradient-bg'>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
							className='text-center'
						>
							<div className="header-with-image-label">
								<LazyLoad>
									<img alt='Yes.Fit Light Logo' title='Yes.Fit Light Logo' src="https://asset.yes.fit/homepage/yf-logo-opaque-light-compressed.png" />
								</LazyLoad>
								<h2 className="header-logo-behind">Can I use my Fitbit to Workout?</h2>								
							</div>
							<p className="standard-text">Of course! Along with 12 more of the most popular activity trackers on the market! You can easily sync all your workouts to any Race or Challenge! </p>
						</Col>
					</Row>
					<Row type='flex'>
						<Col
							xs={{ span: 24 }}
							sm={{ span: 24 }}
							md={{ span: 24 }}
							lg={{ span: 24 }}
							xl={{ span: 24 }}
						>		
							<LazyLoad>						
								<img alt='Yes.Fit Compatible Fitness Trackers' title='Yes.Fit Compatible fitness trackers' src="https://asset.yes.fit/homepage/homepage-tracking-devices-v4-compressed.png" className="tracker-image" />
							</LazyLoad>
						</Col>
					</Row>
				</div>

				<div className='band band-lg white-bg'>

					<Row type='flex'>
						<div className='innerContent split-content-wrapper'>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 14 }}
								lg={{ span: 14 }}
								xl={{ span: 14 }}
								className='split-content-padding'
							>
								<h2>
									Join the Community
								</h2>
								<p>
									Yes.Fit is more than just a group. We’re a <span>team and a family</span> that will cheer you on and keep you motivated, while you reach and conquer your goals. You can be a part of a movement that changes your mood and your life, as well as your body.
								</p>

								<a
									href='https://www.facebook.com/groups/YESvirtualraces'
									className='gradient-shadow-button green large'
									target='_blank'
									title='View Our Facebook Group'
									role="button" 
								>
									Visit Our Facebook Group
								</a>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 10 }}
								xl={{ span: 10 }}
							>
								<div className='inner-content--image'>
									<LazyLoad>
										<img alt='Yes.Fit Social Interaction' title='Yes.Fit Club Social Interaction' src='https://asset.yes.fit/homepage/home-social-compressed.png' />
									</LazyLoad>
								</div>
							</Col>
						</div>
					</Row>				

					<Row type="flex">
						<div className="innerContent testimonials">
							<Col
									xs={{ span: 24 }}
									sm={{ span: 24 }}
									md={{ span: 24 }}
									lg={{ span: 24 }}
									xl={{ span: 24 }}
									className="testimonial--wrapper"
								>
									<div className="header-with-image-label">
									<LazyLoad>
										<img alt='Yes.Fit Light Logo' title='Yes.Fit Light Logo' src="https://asset.yes.fit/homepage/yf-logo-opaque-light-compressed.png" />
									</LazyLoad>
									<h2 className="header-logo-behind">Real People. Real Stories. Real Fun.</h2>								
								</div>
							</Col>
							<Col
									xs={{ span: 24 }}
									sm={{ span: 24 }}
									md={{ span: 24 }}
									lg={{ span: 12 }}
									xl={{ span: 12 }}
									className="testimonial--wrapper"
								>
								<div className="testimonial--item">
									<div className="avatar">
										<div>
											<LazyLoad>
												<img alt='Yes.Fit Real Testimonal' title='Yes.Fit Real Testimonial' src="https://asset.yes.fit/homepage/testimonial-01-compressed.jpg" className="img-fluid" />
											</LazyLoad>
										</div>
									</div>
									<div className="text">
										<div className="quote">
											<LazyLoad>
												<img alt='Yes.Fit Real Testimonal Quote Icon' title='Yes.Fit Real Testimonial Quote Icon'  src="https://asset.yes.fit/homepage/quote.svg" className="img-fluid" />
											</LazyLoad>
										</div>
										<p>I usually slack off in the summer because of how busy we usually are, but Yes.Fit kept me going this summer!</p><strong className="name">Alicia G.</strong>
									</div>
								</div>
							</Col>
						
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 12 }}
								xl={{ span: 12 }}
								className="testimonial--wrapper"
								>
									<div className="testimonial--item">
										<div className="avatar">
											<LazyLoad>
												<img alt='Yes.Fit Real Testimonal' title='Yes.Fit Real Testimonial'  src="https://asset.yes.fit/homepage/testimonial-02-compressed.jpg" className="img-fluid" />
											</LazyLoad>
										</div>
										<div className="text">
											<div className="quote">
												<LazyLoad>
													<img alt='Yes.Fit Real Testimonal Quote Icon' title='Yes.Fit Real Testimonial Quote Icon'  src="https://asset.yes.fit/homepage/quote.svg" className="img-fluid" />
												</LazyLoad>
											</div>
										</div>
										<p>Because of Yes.Fit, I've kept a consistent workout schedule week in week out. I love exercising again and I am so eager to get out there everyday to work towards my goals!</p><strong className="name">E'Ling W.</strong>
									</div>
							</Col>
						</div>
					</Row>

					<Row type="flex">
						<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
							>								
								<div className="header-without-image-label">
									<LazyLoad>
										<img alt='Yes.Fit Top 5000 Fastest Growing Companies in America' title='Yes.Fit Top 5000 Fastest Growing Companies in America' src="https://asset.yes.fit/homepage/Inc5000_Medallion_Color-compressed.png" className="inc-logo" />
									</LazyLoad>
									<h2 className="header-plain dark">Ratings &amp; Reviews</h2>									
								</div>
						</Col>
					</Row>
					<Row type="flex" className="ratings-and-reviews">
						<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
								
							>
								<div className="reviews--item">
									<div className="reviews--item-inner">
										<div className="reviews--item-content">
											<div className="reviews--item-content-top">
												<div aria-label="five star rating"className="rating"><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span></div>
												<div className="reviews--icon">
													<LazyLoad>
													<img alt='Small Apple App Store Icon' title='Small Apple App Store Icon' src="https://asset.yes.fit/homepage/app-store-icon-compressed.jpg" />
													</LazyLoad>
												</div>
											</div>
											
											<h2 className="reviews--item-content-heading">Great App</h2>
											<p className="reviews--item-content-text">I joined this app a few month ago and am love with it. The app is so easy to use and navigate through. The mile markers are a great motivation to keep going. I love all the different themes of the races.</p>
											<p className="reviews--author">by Mrs. Leslie D.</p>
										</div>
									</div>
								</div>
						</Col>

						<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
								
							>
								<div className="reviews--item">
									<div className="reviews--item-inner">
										<div className="reviews--item-content">
											<div aria-label="five star rating" className="reviews--item-content-top">
											<div className="rating"><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span></div>
												<div className="reviews--icon">
													<LazyLoad>
														<img alt='Small Google Play Store Icon' title='Small Google Play Store Icon' src="https://asset.yes.fit/homepage/google-play-store-icon-compressed.png" />
													</LazyLoad>
												</div>
											</div>
											
											<h2 className="reviews--item-content-heading">It's Perfect</h2>
											<p className="reviews--item-content-text">Love this app. I rarely leave reviews, but this one is deserved. The setup and use of this app is PERFECT. 
											All other devs should take notice. And, the fact you can split activities between races? Genius. Will 100% support as long as they are around!</p>
											<p className="reviews--author">by Adam Siler-Waruszewski</p>
										</div>
									</div>
								</div>
						</Col>

						<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
								
							>
								<div className="reviews--item">
									<div className="reviews--item-inner">
										<div className="reviews--item-content">
											<div className="reviews--item-content-top">
												<div aria-label="five star rating" className="rating"><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span></div>
												<div className="reviews--icon">
													<LazyLoad>
														<img alt='Small Apple App Store Icon' title='Small Apple App Store Icon' src="https://asset.yes.fit/homepage/app-store-icon-compressed.jpg" />
													</LazyLoad>
												</div>
											</div>
											
											<h2 className="reviews--item-content-heading">Love this App!</h2>
											<p className="reviews--item-content-text">I love how easy it is to use this app, and to keep track of my completed races, as well as my races in queue. 
You can even compare your race stats to your friends if you like to compete or just cheer each other on.</p>
											<p className="reviews--author">by GreatGb</p>
										</div>
									</div>
								</div>
						</Col>

						<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 24 }}
								xl={{ span: 24 }}
								
							>
								<div className="reviews--item">
									<div className="reviews--item-inner">
										<div className="reviews--item-content">
											<div className="reviews--item-content-top">
												<div aria-label="five star rating" className="rating"><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span><span aria-hidden="true">☆</span></div>
												<div className="reviews--icon">
													<LazyLoad>
														<img alt='Small Google Play Store Icon' title='Small Google Play Store Icon' src="https://asset.yes.fit/homepage/google-play-store-icon-compressed.png" />
													</LazyLoad>
												</div>
											</div>
											
											<h2 className="reviews--item-content-heading">Wonderful Company</h2>
											<p className="reviews--item-content-text">Great App, Wonderful Company! I had to contact them and received fast replies. The medals are amazing quality. 
My son and I loved our T-shirts as well! We can't wait to start a new race tomorrow!</p>
											<p className="reviews--author">by Gamer Jake</p>
										</div>
									</div>
								</div>
						</Col>
					</Row>

				</div>


				<div ref={section => {
						this.Collaborate = section;
					}}
					className='band band band-lg gradient-bg'>
					<Row type='flex'>
						<div className='innerContent split-content-wrapper'>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 12 }}
								xl={{ span: 12 }}
							>
								<div className='inner-content--image'>
									<LazyLoad>
										<img alt='Yes.Fit Partnerships and Brand Collaboration Image' title='Yes.Fit Partnerships and Brand Collaboration' src='https://asset.yes.fit/homepage/partnerships-apparel-image-compressed.png' />
									</LazyLoad>
								</div>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 12 }}
								lg={{ span: 12 }}
								xl={{ span: 12 }}
								className='split-content-padding'
							>
								<h2>
									Brand Promotions &amp; Collaborations
								</h2>
								<p>
								<strong>What is your BIG vision for your Brand? Yes.Fit wants to help!</strong> We can offer many ways to promote your branding while connecting it to a healthy lifestyle.
								</p>

								<a
									href='/partnerships'
									title='View Our Brand Promotions and Collaborations Page'
									className='gradient-shadow-button blue large'
									role="button" 
								>
									Learn More about Brand Collaboration
								</a>
							</Col>
						</div>
					</Row>


				</div>

				<div ref={section => {
						this.CorpWell = section;
					}}
					className='band band band-lg white-bg'>

					<Row type='flex'>
						<div className='innerContent split-content-wrapper'>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 14 }}
								lg={{ span: 14 }}
								xl={{ span: 14 }}
								className='split-content-padding'
							>
								<h2>
									Corporate Wellness
								</h2>
								<p>
								Yes.Fit has created a whole new feature that offers affordable &amp; flexible Fitness Engagement for you and your employees. Getting people motivated towards a common goal is vital and we can help you and your team get there!
								</p>

								<a
									href='/corporate-wellness'
									title='View Our Corporate Wellness Page'
									className='gradient-shadow-button green large'
									role="button" 
								>
									Learn More about Corp Well
								</a>
							</Col>
							<Col
								xs={{ span: 24 }}
								sm={{ span: 24 }}
								md={{ span: 24 }}
								lg={{ span: 10 }}
								xl={{ span: 10 }}
							>
								<div className='inner-content--image'>
									<LazyLoad>
										<img alt='Yes.Fit Corporate Wellness Image' title='Yes.Fit Corporate Wellness' src='https://asset.yes.fit/homepage/corp-well-aspects-compressed.png' />
									</LazyLoad>
								</div>
							</Col>
						</div>
					</Row>	

				</div>
			</div>
		);
	}
}

HomeComponent.propTypes = {};

export default HomeComponent;
